import { http, HttpResponse } from 'msw';
import { mockTruktTmsApiUrl } from '../mocks';
import { EquipmentTypeSearchResponse } from '../services/EquipmentService';

export const handlers = [
  http.get(mockTruktTmsApiUrl('/equipment/types'), () => {
    return HttpResponse.json<EquipmentTypeSearchResponse>({
      page: 0,
      rows: 100,
      total: 23,
      results: [
        {
          type: 'Open',
          isDefault: false,
        },
        {
          type: 'Enclosed',
          isDefault: false,
        },
        {
          type: 'Van',
          isDefault: false,
        },
        {
          type: 'Flatbed',
          isDefault: false,
        },
        {
          type: 'Step Deck',
          isDefault: false,
        },
        {
          type: 'Lowboy / RGN',
          isDefault: false,
        },
        {
          type: 'Reefer',
          isDefault: false,
        },
        {
          type: 'Flatbed/Van/Reefer',
          isDefault: false,
        },
        {
          type: 'Power Only',
          isDefault: false,
        },
        {
          type: 'Driveaway',
          isDefault: false,
        },
        {
          type: 'Box Truck',
          isDefault: false,
        },
        {
          type: 'Lowboy',
          isDefault: false,
        },
        {
          type: 'RGN',
          isDefault: false,
        },
        {
          type: 'Hot Shot',
          isDefault: false,
        },
        {
          type: 'Sprinter Van',
          isDefault: false,
        },
        {
          type: 'Van/Reefer',
          isDefault: false,
        },
        {
          type: 'Van/Flatbed/Step Deck',
          isDefault: false,
        },
        {
          type: 'Flatbed/Step Deck',
          isDefault: false,
        },
        {
          type: 'Van w/Team',
          isDefault: false,
        },
        {
          type: 'Van / Sprinter Van / Box Truck',
          isDefault: false,
        },
        {
          type: 'Flatbed / Step Deck / Hotshot',
          isDefault: false,
        },
        {
          type: 'Flatbed / Step Deck / Hotshot / Lowboy / RGN',
          isDefault: false,
        },
        {
          type: 'Chasis',
          isDefault: false,
        },
      ],
    });
  }),
];
